import React, { useState } from "react";
import "./css/carruselChildren.css";
import btnLeft from "../../resources/img/carrusel/btn-left-green.svg";
import btnRight from "../../resources/img/carrusel/btn-right-green.svg";
import PropTypes from "prop-types";
import CharacterDesingModal from "../modals/characterDesingModal/CharacterDesingModal";

const CarruselChildren = ({
  books = [],
  carouselId = "booksCarousel",
  numberCards = 4,
  character = false,
}) => {
  const [bookData, setBookData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenCharaterModal = (data) => {
    console.log(data);
    setBookData(data);
    setShowModal(true);
  };

  const chunkedBooks = [];
  for (let i = 0; i < books.length; i += numberCards) {
    chunkedBooks.push(books.slice(i, i + numberCards));
  }

  return (
    <div
      id={carouselId}
      className="carousel slide my-5"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-inner">
        {chunkedBooks.map((group, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
          >
            <div className="d-flex justify-content-center gap-5 py-4">
              {group.map((book) => (
                <div
                  key={book.id}
                  className="card shadow border-0 rounded-4 overflow-hidden card-style-children-books-hv cursor-pointer"
                  onClick={() => handleOpenCharaterModal(book)}
                >
                  <img
                    src={book.img}
                    alt={book.title}
                    onContextMenu={(e) => e.preventDefault()}
                    className="size-images-children-hv"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target={`#${carouselId}`}
        data-bs-slide="prev"
      >
        <img src={btnLeft} alt="prev" width="29" height="58" />
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target={`#${carouselId}`}
        data-bs-slide="next"
      >
        <img src={btnRight} alt="next" width="29" height="58" />
      </button>

      {showModal && bookData && (
        <CharacterDesingModal
          key={bookData.id} 
          book={bookData}
          onClose={() => setShowModal(false)}
          character={character}
        />
      )}
    </div>
  );
};

CarruselChildren.propTypes = {
  books: PropTypes.any,
  carouselId: PropTypes.string,
  numberCards: PropTypes.any,
};

export default CarruselChildren;
